import { map, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { InvoiceService } from '../data/invoice.service';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class CreditInvoicesCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: InvoiceService,
    private _navigationService: NavigationService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof MultiselectCommand) {
      if (!command.items || !command.itemsSource) return false;
      return command.id === invoiceCommand.creditAll;
    }
    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof MultiselectCommand) {
      return this._dataService.creditAll(command.items.map(item => item.id)).pipe(
        switchMap(() => {
          this._navigationService.reloadCurrentRoute();
          return of(true);
        })
      );
    }
    if (command instanceof FilteredCommand) {
      return this._dataService
        .creditAllFiltered(
          command.filterProvider.filterState,
          command.includedIds,
          command.excludedIds,
          command.totalAffectedItemsControlValue
        )
        .pipe(map(() => true));
    }
  }
}
